import logger from 'utils/logging/faro';

import { getMeetingByRoomId } from './getMeetingByRoomId';
import { UpdateMeetingRequest } from './types';
import { updateMeeting } from './updateMeeting';

/**
 * Fire-and-forget: mirrors a Matrix-room state change into the IS record.
 * Never throws — Matrix is the enforcement authority; IS is metadata only.
 */
export const syncMeetingFromRoom = async (roomId: string, update: UpdateMeetingRequest): Promise<void> => {
  try {
    const meeting = await getMeetingByRoomId(roomId);
    if (!meeting) return;
    await updateMeeting(meeting.id, update);
  } catch (error) {
    logger.warn('Failed to sync meeting metadata to IS', { roomId, update, error });
  }
};
